import React, {FC} from 'react'
import MainAsideMenuLayout from "@layouts/mainAsideMenuLayout/MainAsideMenuLayout";


const BudgetPage: FC<any> = (props) => {

  let {} = props

  return (
    <MainAsideMenuLayout>
      {/*<BackLinkLayout>*/}
      <div>BudgetPage
      </div>
      {/*</BackLinkLayout>*/}
    </MainAsideMenuLayout>
  )
}

export default BudgetPage;